import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { toast } from "@heroui/react";
import { v4 as uuidv4 } from "uuid";
import { useAuth } from "@repo/context/auth/auth";
import { TemplateTracePanel } from "@repo/ui/pages/template_service/trace/TemplateTracePanel";
import DecodeHistory from "@repo/ui/pages/template_service/trace/DecodeHistory";
import { SafeAreaContainer } from "@/components/layout/safe-area-container";
import { buildCos, uploadFileToOss } from "@/utils/cos/cos";
import { appConfig } from "@/config/app-config";

export const Route = createFileRoute("/template_trace")({
  component: TemplateTrackPage,
});

export default function TemplateTrackPage() {
  const { isAuthenticated, userInfo } = useAuth();

  const uploadFile = useCallback(
    async (file: File, onProgress: (percent: number) => void): Promise<string> => {
      if (!userInfo?.uid) {
        throw new Error("未登录");
      }
      const extMatch = file.name.match(/(\.[^./\\]+)$/);
      const ext = extMatch ? extMatch[1] : "";
      const storageBase = `${Date.now()}_${uuidv4()}${ext}`;
      const fileKey = `temp/${userInfo.uid}/psd/${storageBase}`;
      const cos = buildCos(fileKey);
      await uploadFileToOss({
        cos,
        fileKey,
        file,
        bucket: appConfig.cos.tplBucket,
        region: appConfig.cos.tplBucketRegion,
        onProgress: (progressData) => {
          onProgress(Math.round(progressData.percent * 100));
        },
      });
      return fileKey;
    },
    [userInfo?.uid],
  );

  return (
    <SafeAreaContainer className="bg-background" customPaddingBottom="2rem">
      <div className="px-4 pt-4 pb-6 max-w-2xl mx-auto w-full space-y-6">
        <TemplateTracePanel
          uploadFile={uploadFile}
          isAuthenticated={!!isAuthenticated}
          onLoginRequired={() => toast.danger("请重新从 App 打开本页面")}
        />
        <DecodeHistory enabled={!!isAuthenticated} />
      </div>
    </SafeAreaContainer>
  );
}
